import React, { useState } from 'react';
import styled from 'styled-components';
import emailjs from "emailjs-com";
// Styling components
const FormContainer = styled.div`
  min-height: 100vh;
//   background-color: #000000;
  color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Form = styled.form`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  
`;

const Label = styled.label`
  font-size: 16px;
  color: #034C53;
  font-weight: 500;
`;

const Input = styled.input`
  padding: 12px;
  border-radius: 4px;
  background-color:#a7a999;
  border: 1px solid #333;
  color: white;
  font-size: 16px;
  width: 96%;
  outline: none;
  border:none;
&::placeholder {
    color:rgb(71, 60, 60);
    opacity: 1; /* Ensure it's fully visible */
  }
  &:focus {
    outline: none;
    border-color: #66BFBF;
  }
`;

const Select = styled.select`
  padding: 12px;
  border-radius: 4px;
  background-color:#a7a999;

  border:none;
  color: white;
  font-size: 16px;
  width: 100%;
  appearance: none;
  position: relative;
  
  &:focus {
    outline: none;
    border-color: #66BFBF;
  }
`;

const SelectContainer = styled.div`
  position: relative;
  width: 100%;
  &::after {
    content: '▼';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    font-size: 12px;
  }
`;

const DisclaimerText = styled.p`
  font-size: 14px;
  color: #ff6b6b;
  text-align: center;
  margin:0;

`;

const SubmitButton = styled.button`
  background-color: #66BFBF;
  color: #034C53;
  padding: 16px 24px;
  font-size: 18px;
  border-radius: 8px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  margin-top: 10px;
  transition: 0.3s ease;

  &:hover {
    background-color: #EEF1DA;
  }
`;
const DemoForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    businessName: "",
    aiVoice: "Victoria - American Accent (Dentist Receptionist)",
    foundUs: "",
    whatsappNumber: "",
    phoneNumber: "",
  });

  
  const [status, setStatus] = useState({ loading: false, success: null, message: "" });

  const [errors, setErrors] = useState({
    whatsappNumber: "",
    phoneNumber: ""
  });

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^\+\d{7,15}$/; // Allows + followed by 7-15 digits
    return phoneRegex.test(number);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    // Phone validation
    if (name === "whatsappNumber" || name === "phoneNumber") {
      if (!validatePhoneNumber(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Invalid phone number format. Use + followed by digits."
        }));
      
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: ""
        }));
      }
    }
  };

  const handleSubmit = (e) => {
   
      e.preventDefault();
      setStatus((prevErrors) => ({
        ...prevErrors, loading: true
      }));
  
      let hasError = false; // Flag to track validation errors

      // Validate WhatsApp number
      if (!validatePhoneNumber(formData.whatsappNumber)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          whatsappNumber: "Invalid WhatsApp number."
        }));
        hasError = true;
      }
    
      // Validate Phone number
      if (!validatePhoneNumber(formData.phoneNumber)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          phoneNumber: "Invalid Phone number."
        }));
        hasError = true;
      }
    
      // If there's an error, stop execution and reset loading
      if (hasError) {
        setStatus((prevStatus) => ({
          ...prevStatus,
          loading: false
        }));
        return;
      }
    
  
     
  
      
    // EmailJS Configuration
    emailjs
      .send(
       "service_e7thych",   // Replace with your Email.js Service ID
        "template_e04ztke", // Replace with your EmailJS template ID
        {
          
          name: formData.name,
          email: formData.email,
          business: formData.businessName,
          aiVoice: formData.aiVoice,
          foundUs: formData.foundUs,
          whatsappNumber: formData.whatsappNumber,
          number: formData.phoneNumber,
        },
        "lMjHqDPRgZhm9hwZV" // Replace with your EmailJS user ID (public key)
      )
      .then(() => {
        setTimeout(() => {
          setFormData({
            name: "",
            email: "",
            businessName: "",
            aiVoice: "Victoria - American Accent (Dentist Receptionist)",
            foundUs: "",
            whatsappNumber: "",
            phoneNumber: "",
          })
          setStatus({ loading: false, success: true, message: "Email sent successfully!" });
        }, 2000);
      })
      .catch(() => {
        setTimeout(() => {
          setStatus({ loading: false, success: false, message: "Failed to send email." });
        }, 2000);
      });
  };


  return (
    <FormContainer>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label>Name</Label>
          <Input type="text" name="name" value={formData.name} onChange={handleChange} required />
          {errors.name && <small style={{ color: "red" }}>{errors.name}</small>}
        </FormGroup>

        <FormGroup>
          <Label>Email</Label>
          <Input type="email" name="email" value={formData.email} onChange={handleChange} required />
          {errors.email && <small style={{ color: "red" }}>{errors.email}</small>}
        </FormGroup>

        <FormGroup>
          <Label>Business Name</Label>
          <Input type="text" name="businessName" value={formData.businessName} onChange={handleChange} required />
          {errors.businessName && <small style={{ color: "red" }}>{errors.businessName}</small>}
        </FormGroup>

        <div style={{ display: "flex", width: "100%", gap: "20px", justifyContent: "space-between" }}>
          <FormGroup>
            <Label>AI Voice Facilitator</Label>
            <SelectContainer>
              <Select name="aiVoice" value={formData.aiVoice} onChange={handleChange} required>
                <option value="Victoria - American Accent (Dentist Receptionist)">
                  Victoria - American Accent (Dentist Receptionist)
                </option>
                <option value="Alex - British Accent">Alex - British Accent</option>
                <option value="Emma - Australian Accent">Emma - Australian Accent</option>
                <option value="David - Indian Accent">David - Indian Accent</option>
              </Select>
            </SelectContainer>
          </FormGroup>

          <FormGroup>
            <Label>How did you find us?</Label>
            <SelectContainer>
              <Select name="foundUs" value={formData.foundUs} onChange={handleChange} required>
                <option value="" disabled>Select...</option>
                <option value="social">Social Media</option>
                <option value="search">Search Engine</option>
                <option value="referral">Referral</option>
                <option value="advertisement">Advertisement</option>
              </Select>
            </SelectContainer>
            {errors.foundUs && <small style={{ color: "red" }}>{errors.foundUs}</small>}
          </FormGroup>
        </div>

        <FormGroup>
          <Label>WhatsApp Number</Label>
          <Input type="tel" name="whatsappNumber" value={formData.whatsappNumber} onChange={handleChange} required />
          {errors.whatsappNumber && <small style={{ color: "red" }}>{errors.whatsappNumber}</small>}
        </FormGroup>

        <FormGroup>
          <Label>Phone Number *To Be Used For Demo Call*</Label>
          <Input type="tel" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
          {errors.phoneNumber && <small style={{ color: "red" }}>{errors.phoneNumber}</small>}
        </FormGroup>

        <DisclaimerText>
          By submitting, you agree to receive follow-up calls and emails from arrangemessage.com
        </DisclaimerText>

        <SubmitButton type="submit" disabled={status.loading}>
          {status.loading ? "Sending..." : "Experience The Future"}
        </SubmitButton>

        {status.message && (
          <p style={{ color: status.success ? "green" : "red" }}>{status.message}</p>
        )}
      </Form>
    </FormContainer>
  );
};

export default DemoForm;